import styled, { css } from 'styled-components';
import {
    colorBlack,
    colorWhite,
    mediaSm,
    mediaXs,
} from 'theme/theme-helper-selectors';

export const Container = styled.div`
    margin: 100px 0 0 0;

    @media (${mediaSm}) {
        margin: 36px 0 0 0;
    }
`;

export const Title = styled.h2`
    font-size: 72px;
    font-weight: 400;
    line-height: 74px;
    margin: 0 0 40px;
    text-align: left;

    @media (${mediaSm}) {
        font-size: 42px;
        line-height: 44px;
        margin: 0 0 36px;
    }

    @media (${mediaXs}) {
        font-size: 24px;
        font-weight: 500;
        line-height: 27px;
    }
`;

export const GrayBox = styled.div`
    background-color: #f4f7fa;
    border-radius: 16px;
    padding: 24px 40px;
    display: flex;
    flex-direction: column;
    gap: 32px;

    @media (${mediaSm}) {
        padding: 16px;
        gap: 24px;
    }
`;

export const Description = styled.p`
    font-size: 24px;
    line-height: 27px;
    max-width: 690px;
    margin: 0;
    font-weight: 300;

    @media (${mediaSm}) {
        font-size: 18px;
        line-height: 21px;
    }
`;

export const BottomSection = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    @media (${mediaSm}) {
        flex-direction: column;
        align-items: flex-start;
        gap: 24px;
    }
`;

export const ControlsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const ChooseLangText = styled.span`
    font-size: 24px;
    line-height: 27px;
    font-weight: 400;
`;

export const LangSwitcher = styled.div`
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
`;

export const LangButton = styled.button<{ $isActive?: boolean }>`
    padding: 5px 16px;
    border-radius: 24px;
    font-size: 12px;
    line-height: 14px;
    font-weight: 500;
    text-transform: uppercase;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    letter-spacing: 12%;

    ${({ $isActive }) =>
        $isActive
            ? css`
                  background-color: #29ccb1;
                  color: ${colorBlack};
              `
            : css`
                  background-color: ${colorWhite};
                  color: ${colorBlack};
              `}
`;
